<template>
    <modal :open="showModal" @close="closeModal">
        <template v-if="showModal">
            <div class="modal-header">
                <button @click="closeModal" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <span class="text-primary icon icon-check-circle icon-5x"></span>
                    <h3 class="text-primary">{{ $t('globals.confirm_action') }}</h3>
                    <p class="mb-0" v-html="$t('organization_payments.mark_as_paid_question', {
                        emphasizedOpen: '<span class=&quot;font-semibold&quot;>',
                        invoice: invoice.identificator,
                        organization: invoice.organization.name,
                        emphasizedClose: '</span>',
                    })"></p>
                    <p v-html="$t('organization_payments.mark_as_paid_irreversible_action_info', {
                        emphasizedOpen: '<span class=&quot;font-semibold&quot;>',
                        emphasizedClose: '</span>',
                    })"></p>
                    <p v-html="$t('globals.type_to_confirm_action', {
                        emphasizedOpen: '<span class=&quot;font-semibold&quot;>',
                        text: invoice.identificator,
                        emphasizedClose: '</span>',
                    })"></p>
                    <form @submit.prevent="onSubmit" @keydown="form.errors.forget($event.target.name)">
                        <div :class="{ 'has-error' : form.errors.has('verification_text') }">
                            <input id="verification_text" name="verification_text" type="text" class="form-control" v-model="form.verification_text" />
                            <p class="help-block" v-if="form.errors.has('verification_text')" v-text="form.errors.get('verification_text')"></p>
                        </div>
                        <div class="m-t-lg">
                            <button @click="closeModal" class="btn btn-default mr-2" type="button">{{ $t('globals.cancel') }}</button>
                            <button :disabled="form.errors.any() || form.busy" class="btn btn-primary" type="submit">
                                <span v-if="form.busy" class="icon icon-spinner mr-1 spin"></span>
                                {{ $t('organization_payments.mark_as_paid') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer"></div>
        </template>
    </modal>
</template>

<script>
import Modal from '../../../user/partials/modal.vue';

export default {
    components: {
        'modal': Modal,
    },

    data() {
        return {
            showModal: false,
            invoice: null,
            form: new Form({
                invoice_id: '',
                verification_text: '',
            }),
        };
    },

    created() {
        Bus.$on('showMarkInvoiceAsPaidModal', ({ invoice }) => {
            this.openModal(invoice);
        });
    },

    methods: {
        openModal(invoice) {
            this.invoice = invoice;
            this.form.invoice_id = this.invoice.id;
            this.form.verification_text = '';
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
            this.invoice = null;
            this.resetForm();
        },

        resetForm() {
            this.form = new Form({
                invoice_id: '',
                verification_text: '',
            });
        },

        onSubmit() {
            Globals.post('/kiosk/mark-invoice-as-paid', this.form)
                .then(() => {
                    const flash = { type: 'success', message: this.$t('organization_payments.invoice_marked_as_paid') };
                    window.sessionStorage.setItem('flash', JSON.stringify(flash));
                    window.location.reload();
                })
                .catch(() => {
                    if (this.form.errors.has('verification_text')) {
                        return;
                    }
                    const message = this.form.errors.has('invoice_id')
                        ? this.form.errors.get('invoice_id')
                        : this.$t('globals.unexpected_error');
                    this.closeModal();
                    window.toastr.clear();
                    window.toastr.error(message);
                });
        },
    },
};
</script>
